import React from 'react';
import styled from 'styled-components';

const Striked = styled.span`
    font-size: 0.9rem;
    color: #999;
    text-decoration: line-through;
`;

const Info = styled.span`
    color: gray;
    font-weight: normal;
    font-size: 0.9rem;
`;

const PriceInner = ({ price, info = "", qty = 1, discount = 0, reverse = false, className, ...props }) => {
  if (discount > 0) {
    const price_eur_round = Math.round((price / 1.95583) * 100) / 100

    const discounted_price = (price_eur_round - (price_eur_round * (discount / 100))) * qty;

    const price_eur = new Intl.NumberFormat("bg-BG", { style: "currency", currency: "EUR" }).format(
      (discounted_price * qty),
    );

    const price_lv = new Intl.NumberFormat("bg-BG", { style: "currency", currency: "BGN" }).format(
      (price * qty),
    );

    return (
      <h3 className={className} {...props}>
        {reverse ? (<Striked>{price_lv}</Striked>) : (<></>)}
        {discounted_price}лв.
        {!reverse ? (<Striked>{price_lv}</Striked>) : (<></>)}
        {info ? <Info>{info}</Info> : null}
        &nbsp;/ {price_eur}
      </h3>
    );
  } else {
    const price_eur_round = Math.round((price / 1.95583) * 100) / 100

    const price_eur = new Intl.NumberFormat("bg-BG", { style: "currency", currency: "EUR" }).format(
      (price_eur_round * qty),
    );

    const price_lv = new Intl.NumberFormat("bg-BG", { style: "currency", currency: "BGN" }).format(
      (price * qty),
    );

    return (
      <h3 className={className} {...props}>
        {price_eur} &nbsp;/ <span>{price_lv}</span>
        {info ? <Info>{info}</Info> : null}
      </h3>
    );
  }
};

const Price = styled(PriceInner)`
    margin: 0;
    padding-top: 7px;
    font-weight: 600;

    span {
      font-weight: normal;
    }
`;

export default Price;